<div class="order-details-container">
    <div class="page-header-container">
      <div class="header-composed mb-3">
        <a (click)="navigateBack()" class="text-title-2 back-ref">
          {{(navigationState | navigatedFrom : 'Sales to Reverse Distributors' : '/inventory/sales-to-reverse-distributors-history')?.name}}
        </a>
        <div class="text-title-2 header">
            Reverse Distributor Sale Details
        </div>
      </div>
      <div *ngIf="orderWithDetails">
        <div class="page-subheader">
          <div class="inventory-details">
            <div class="label">Reverse Distributor:</div>
            <div class="value">
              {{orderWithDetails?.soldReturnedTo}}
            </div>
          </div>
          <div class="inventory-details" *ngIf="orderWithDetails?.purchaseOrder">
            <div class="label">PO #:</div>
            <div class="value">
              {{orderWithDetails?.purchaseOrder}}
            </div>
          </div>
          <div class="inventory-details" *ngIf="orderWithDetails?.invoiceNumber">
            <div class="label">Invoice #:</div>
            <div class="value">
              {{orderWithDetails?.invoiceNumber}}
            </div>
          </div>
          <div class="inventory-details" *ngIf="orderWithDetails?.csos">
            <div class="label">CSOS #:</div>
            <div class="value">
              {{orderWithDetails?.csos}}
            </div>
          </div>
          <div class="inventory-details" *ngIf="orderWithDetails?.shipDate">
            <div class="label">Ship Date:</div>
            <div class="value">
              {{orderWithDetails.shipDate | date}}
            </div>
          </div>
          <div class="inventory-details">
            <div class="label">NDCs Received:</div>
            <div class="value">
              {{orderWithDetails?.orderLines?.length}} NDC{{orderWithDetails?.orderLines?.length !== 1 ? 's' : ''}}
            </div>
          </div>
        </div>
        <div class="inventory-details">
          <div class="label">Performed:</div>
          <div class="value">{{orderWithDetails?.createDate | formattedDate: 'MM d a, HH:mm'}}
          </div>
          <span class="vertical-divider"> | </span>
          <div class="label">Recorded:</div>
          <div class="value">
            {{orderWithDetails?.userFirstName}}
            <ng-container *ngIf="orderWithDetails?.userLastName && orderWithDetails?.userLastName[0]">
              {{orderWithDetails?.userLastName[0]}}.;
            </ng-container>
            {{orderWithDetails?.createDate | formattedDate: 'MM d a, HH:mm'}}
          </div>
        </div>
        <div #buyerSupplier>
          <app-supplier-buyer-sale-details class="block pt-8" *ngIf="orderWithDetails?.buyerDetails"
            [readOnly]="true"
            [supplier]="orderWithDetails?.supplierDetails"
            [buyer]="orderWithDetails.buyerDetails">
          </app-supplier-buyer-sale-details>
        </div>
      </div>
    </div>
    <div #fileAttachment>
      <app-file-attachment 
        [files]="orderFiles$ | async"
        [fileTypes]="fileTypes"
        [requiresSignature]="true"
        [csosControl]="form.get('csos')"
        (downloadFile)="downloadFile($event)"
        (saveFiles)="saveAttachmentsList($event)"
      >
      </app-file-attachment>
    </div>
  
    <app-generic-table
          [ngStyle]="{'--table-height': calculateTableHeight()}"
          [data]="orderWithDetails?.orderLines" 
          [columns]="columns"
          [withDetailsOption]="false"
    ></app-generic-table>
  </div>